module.exports = __webpack_public_path__ + "img/cyber-security-awareness.8958929e.png";